import React from 'react';
import { Link } from 'react-router-dom';

export default function TermsOfUse() {
  return (
    <div className="min-h-screen bg-background text-foreground px-4 py-10">
      <div className="max-w-3xl mx-auto flex flex-col gap-6">
        <div>
          <Link to="/register" className="text-sm text-primary hover:underline">&larr; Back to registration</Link>
        </div>
        <h1 className="text-2xl font-bold">Terms of Use</h1>
        <p className="text-xs text-muted-foreground">Last updated: April 2026</p>

        <section className="flex flex-col gap-2">
          <h2 className="text-base font-semibold">1. Informational Purpose Only</h2>
          <p className="text-sm text-muted-foreground">
            Jigri is a personal research and analysis tool. All screener signals, backtests,
            strategy outputs, and any other content generated by this platform are provided
            strictly for informational and educational purposes. Nothing on this platform
            constitutes financial advice, investment advice, trading advice, or any other
            type of advice.
          </p>
        </section>

        <section className="flex flex-col gap-2">
          <h2 className="text-base font-semibold">2. Not a Registered Advisor</h2>
          <p className="text-sm text-muted-foreground">
            Jigri is not a SEBI-registered investment advisor, broker, dealer, or any other
            regulated financial entity. Use of this platform does not create any
            advisor–client relationship.
          </p>
        </section>

        <section className="flex flex-col gap-2">
          <h2 className="text-base font-semibold">3. User Responsibility for Trading Decisions</h2>
          <p className="text-sm text-muted-foreground">
            You are solely and exclusively responsible for every trading or investment
            decision you make. Any action you take based on signals, backtests, or other
            outputs from this platform is taken entirely at your own risk. Jigri and its
            operators bear no responsibility or liability whatsoever for any financial
            loss, damage, or adverse outcome resulting from your use of this platform,
            including losses arising from live trading, paper trading, or any other
            feature.
          </p>
        </section>

        <section className="flex flex-col gap-2">
          <h2 className="text-base font-semibold">4. No Guarantee of Accuracy or Profit</h2>
          <p className="text-sm text-muted-foreground">
            Jigri makes no representation or warranty that any signal, output, or strategy
            is accurate, complete, or profitable. Market conditions change rapidly and past
            performance — including backtest results — is not indicative of future results.
            Backtest results are hypothetical and subject to significant limitations,
            including look-ahead bias, survivorship bias, and the inability to account for
            real-world execution slippage and costs.
          </p>
        </section>

        <section className="flex flex-col gap-2">
          <h2 className="text-base font-semibold">5. Risk Disclosure</h2>
          <p className="text-sm text-muted-foreground">
            Trading and investing in financial markets involves substantial risk of loss.
            You may lose some or all of your invested capital. Live trading features
            connect to third-party broker APIs; Jigri is not responsible for broker errors,
            order failures, API downtime, or any losses resulting from automated or
            manual order placement. You should only trade with capital you can afford to
            lose entirely.
          </p>
        </section>

        <section className="flex flex-col gap-2">
          <h2 className="text-base font-semibold">6. Third-Party Data</h2>
          <p className="text-sm text-muted-foreground">
            Price data and fundamental data are sourced from third-party providers (e.g.,
            Yahoo Finance, Trendlyne). Jigri does not guarantee the accuracy, timeliness,
            or completeness of such data.
          </p>
        </section>

        <section className="flex flex-col gap-2">
          <h2 className="text-base font-semibold">7. Acceptance</h2>
          <p className="text-sm text-muted-foreground">
            By creating an account you confirm that you have read, understood, and agreed
            to these Terms of Use. If you do not agree, do not create an account or use
            this platform.
          </p>
        </section>

        <p className="text-xs text-muted-foreground mt-4">
          See also: <Link to="/privacy" className="text-primary hover:underline">Privacy Policy</Link>
        </p>
      </div>
    </div>
  );
}
